/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  autofocus: Boolean,
  clearable: Boolean,
  "default": {
    type: [String, Function]
  },
  disabled: Boolean,
  filter: {
    type: Function
  },
  filterable: {
    type: Boolean,
    "default": true
  },
  highlightKeyword: {
    type: Boolean,
    "default": true
  },
  inputProps: {
    type: Object
  },
  options: {
    type: Array
  },
  panelBottomContent: {
    type: [String, Function]
  },
  panelTopContent: {
    type: [String, Function]
  },
  placeholder: {
    type: String,
    "default": void 0
  },
  popupProps: {
    type: Object
  },
  readonly: Boolean,
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  status: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  textareaProps: {
    type: Object
  },
  tips: {
    type: [String, Function]
  },
  triggerElement: {
    type: [String, Function]
  },
  value: {
    type: String,
    "default": void 0
  },
  modelValue: {
    type: String,
    "default": void 0
  },
  defaultValue: {
    type: String,
    "default": ""
  },
  onBlur: Function,
  onChange: Function,
  onClear: Function,
  onCompositionend: Function,
  onCompositionstart: Function,
  onEnter: Function,
  onFocus: Function,
  onSelect: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
